import dayjs from 'dayjs';
import { statusLabels } from '../team-holidays/teamHolidayStatus';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

const parseDate = value => typeof value === 'string' ? dayjs(value.slice(0, 10), 'YYYY-MM-DD', true) : dayjs('');

export function isValidHolidayPeriod(from, to) {
  const start = parseDate(from);
  const end = parseDate(to);
  return start.isValid() && end.isValid() && !end.isBefore(start, 'day');
}

export function calendarDays(from, to) {
  const start = parseDate(from);
  const end = parseDate(to);
  if (!start.isValid() || !end.isValid() || end.isBefore(start, 'day')) return [];
  return Array.from({ length: end.diff(start, 'day') + 1 }, (_, index) => start.add(index, 'day'));
}

export const planningStatusLabels = statusLabels;

export function holidayPlanningColor(status) {
  return Object.hasOwn(planningStatusLabels, status) ? `var(--holiday-status-${status}-color)` : '#909399';
}

export function holidayBars(holidays, days) {
  if (!days.length) return [];
  const first = days[0];
  const last = days[days.length - 1];
  return (Array.isArray(holidays) ? holidays : []).flatMap(holiday => {
    const start = parseDate(holiday.fromDate);
    const end = parseDate(holiday.toDate);
    if (!start.isValid() || !end.isValid() || end.isBefore(start, 'day') || end.isBefore(first, 'day') || start.isAfter(last, 'day')) return [];
    const startDay = Math.max(0, start.diff(first, 'day'));
    const endDay = Math.min(days.length - 1, end.diff(first, 'day'));
    return [{ startDay, width: endDay - startDay + 1, color: holidayPlanningColor(holiday.status), title: `${planningStatusLabels[holiday.status] || 'Sin estado'} · ${holiday.observations || 'Vacaciones'}`, text: holiday.observations || 'Vacaciones', details: holiday }];
  });
}
